import { mapGetters } from 'vuex';
import ContactlessSummary from './ContactlessSummary';  
import PriceCard from './PriceCard'
import Button from '../../shared/Button'
import ProductDetails from '../ProductDetails'
import Accounting from '../../../mixins/accounting'
import PriceCardPlaceholder from '../PriceCardPlaceholder'
import ImageUrlFallback from '../../../mixins/imageUrlFallback'
import VehicleVisualSummary from './VehicleVisualSummary'
import VehicleCardLocalisations from '../../../lang/VehicleCard';
import BookingsLocalisations from '../../../lang/bookings';
import merge from 'lodash/merge';
require('../scss/vehicle-card.scss');
require('./scss/drive-go-vehicle-card.scss');


export default {
    name: 'drive-go-vehicle-card',

    components: {
        'gm-button': Button,
        PriceCard,
        PriceCardPlaceholder,
        ProductDetails,
        VehicleVisualSummary,
        ContactlessSummary
    },

    mixins:[Accounting, ImageUrlFallback],

    props: ['vehicle', 'buy', 'labels', 'locale', 'selectVehicle', 'showTermsAndConditions', 'handleLogin'],

    template: `
        <div class="vehicle drive-go-vehicle-card d-flex" v-if="currentVehicle">
            <vehicle-visual-summary :vehicle="vehicle" :labels="labels" :currentVehicle="currentVehicle" :currencyIsChanging="currencyIsChanging" :activeProduct="activeProduct"></vehicle-visual-summary>
            <contactless-summary></contactless-summary>
            <div class="price-block-mobile">
                <div class="upgrade-product" @click="showBenefits">
                    <span>{{ $t('bookings.drive_and_go.premium_plus_benefits_also_included') }}</span>
                    <span class="upgrade-product-arrow" :class="{'active': showKeylessBenefits}"></span>
                </div>
                <transition name="fade">
                    <div v-if="showKeylessBenefits">
                        <product-details
                            :show-terms-and-conditions="showTermsAndConditions"
                            :product="activeProduct"
                            :currency-is-changing="currencyIsChanging"
                        ></product-details>
                    </div>
                </transition>
                <div class="book-basic">
                    <div class="basic-per-day">
                        <img :src="icons.PMP" :alt="productLabels.PMP">
                        <span>{{ $tc('VehicleCard.days', quoteHireDuration) }}</span>
                    </div>
                    <gm-button
                        @click="selectVehicle(vehicle, activeProduct.id);"
                        v-if="vehicle.is_drive_and_go && activeProduct.is_available"
                    >
                        {{ price(activeProduct) }}
                        <img src="/images/right-arrow-white.png" class="right-arrow-white" alt="right arrow white">
                    </gm-button>
                    <gm-button
                        top-right-radius="0"
                        top-left-radius="0"
                        :disabled="true"
                        v-if="!activeProduct.is_available"
                    >
                        {{ $t('VehicleCard.age_limit', { age: activeProduct.minimum_age }) }}
                    </gm-button>
                </div>
            </div>
            <price-card
                :class="{ active: true }"
                :key="activeProduct.type"
                :product="activeProduct"
                :vehicle="currentVehicle"
                :labels="labels"
                :buy="buy"
                :show-terms-and-conditions="showTermsAndConditions"
                :currency-is-changing="currencyIsChanging"
                :select-vehicle="selectVehicle"
                :selected-currency="selectedCurrency"
                :user="user"
                :handle-login="handleLogin"
            ></price-card>  
        </div>
    `,
    i18n: merge(VehicleCardLocalisations, BookingsLocalisations),
    data() {
        return {
            currencyIsChanging:false,
            imageErrorUrls:[],
            currentVehicle: null,
            product: null,
            showKeylessBenefits: false,
            products: [],
            icons: {
                PMP: "/images/vehicle-listing/premium-plus-badge.svg"
            },
            productLabels: {
                PMP: "premium plus+"
            }

        }
    },

    mounted() {
        this.currentVehicle = this.vehicle;
        window.bus.$on('currency.changed',this.currencyChanging);
    },

    beforeDestroy() {
        window.bus.$off('currency.changed',this.currencyChanging);
    },

    watch:{
        vehicle: function(vehicle) {
            this.currencyIsChanging = false;
        }
    },

    computed: Object.assign({
            activeProduct(){
                const activeProducts = this.vehicle.products.data.filter((product) => product.type === 'PMP');
                return activeProducts.length > 0 ? activeProducts[0] : {};
            },
            pluralizationEnabled() {
                return !['tr'].includes(this.locale);
            },
            userLoyalty() {
                if (!this.user) {
                    return null;
                }

                const data = this.user.loyalty_level.data;

                return {
                    name: data.name,
                    image: `/images/loyalty-icons/medals/${data.slug}.svg`,
                };
            },
            loyaltyDiscountApplied() {
                return this.vehicle.loyalty_discount_applied && this.userLoyalty;
            },
            pickupLocationIsUK() {
                return this.pickupLocation.country && this.pickupLocation.country.data.id === 1;
            },
            placeholderSpaces(){
                return 4 - this.products.length;
            }
        },
        mapGetters({
            quotePaymentType: 'quotePaymentType',
            quoteHireDuration: 'quoteHireDuration',
            selectedCurrency: 'selectedCurrency',
            user: 'getQuoteUser',
            quote: 'getQuote',
            pickupLocation: 'getPickupLocation',
        })
    ),

    methods: {
        currencyChanging(){
            this.currencyIsChanging = true;
        },
        setActiveProduct(vehicle, product) {
            this.products = this.products.map(aProduct => {
                aProduct.active = false;
                return aProduct;
            });
            product.active = true;
        },
        showBenefits() {
            this.showKeylessBenefits = !this.showKeylessBenefits;
        },
    }
};



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/Components/quotes/DriveGo/DriveGoVehicleCard.js